/**
 * Class for loading KTX2 files
 * !!! Experimental Extension Subject to Changes !!!
 * @hidden
 */
var KhronosTextureContainer2 = /** @class */ (function () {
    function KhronosTextureContainer2(engine) {
        var _this = this;
        if (!KhronosTextureContainer2._ModulePromise) {
            KhronosTextureContainer2._ModulePromise = new Promise(function (resolve) {
                LIBKTX().then(function (module) {
                    module.GL.makeContextCurrent(module.GL.registerContext(engine._gl, { majorVersion: engine._webGLVersion }));
                    KhronosTextureContainer2._TranscodeFormat = _this._determineTranscodeFormat(module.TranscodeTarget, engine.getCaps());
                    resolve({ module: module });
                });
            });
        }
    }
    KhronosTextureContainer2.prototype.uploadAsync = function (data, internalTexture) {
        return KhronosTextureContainer2._ModulePromise.then(function (moduleWrapper) {
            var module = moduleWrapper.module;
            var ktxTexture = new module.ktxTexture(data);
            try {
                if (ktxTexture.isBasisSupercompressed) {
                    ktxTexture.transcodeBasis(KhronosTextureContainer2._TranscodeFormat, 0);
                }
                internalTexture.width = internalTexture.baseWidth = ktxTexture.baseWidth;
                internalTexture.height = internalTexture.baseHeight = ktxTexture.baseHeight;
                internalTexture.generateMipMaps = false;
                var result = ktxTexture.glUpload();
                if (result.error === 0) {
                    internalTexture._webGLTexture = result.texture;
                }
                else {
                    throw new Error("Failed to upload: " + result.error);
                }
                internalTexture.isReady = true;
            }
            finally {
                ktxTexture.delete();
            }
        });
    };
    KhronosTextureContainer2.prototype._determineTranscodeFormat = function (transcodeTarget, caps) {
        if (caps.s3tc) {
            return transcodeTarget.BC1_OR_3;
        }
        else if (caps.etc2) {
            return transcodeTarget.ETC;
        }
        throw new Error("No compatible format available");
    };
    /**
     * Checks if the given data starts with a KTX2 file identifier.
     * @param data the data to check
     * @returns true if the data is a KTX2 file or false otherwise
     */
    KhronosTextureContainer2.IsValid = function (data) {
        if (data.byteLength >= 12) {
            // '«', 'K', 'T', 'X', ' ', '2', '0', '»', '\r', '\n', '\x1A', '\n'
            var identifier = new Uint8Array(data.buffer, data.byteOffset, 12);
            if (identifier[0] === 0xAB && identifier[1] === 0x4B && identifier[2] === 0x54 && identifier[3] === 0x58 && identifier[4] === 0x20 && identifier[5] === 0x32 &&
                identifier[6] === 0x30 && identifier[7] === 0xBB && identifier[8] === 0x0D && identifier[9] === 0x0A && identifier[10] === 0x1A && identifier[11] === 0x0A) {
                return true;
            }
        }
        return false;
    };
    return KhronosTextureContainer2;
}());
export { KhronosTextureContainer2 };
//# sourceMappingURL=khronosTextureContainer2.js.map